module.exports = __webpack_public_path__ + "img/service-dashujuzhengxin3.b6e89d2a.svg";